class SwymWishlistButton extends HTMLElement {
  constructor() {
    super();

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(this.initializeSwymButton.bind(this));
  }

  async initializeSwymButton(swat) {
    const wishlistButton = this.querySelector('.swym-button');

    wishlistButton.addEventListener('click', event => {
      event.stopPropagation();

      let { epi, empi, du } = wishlistButton.dataset;
      let product = { epi, empi, du };

      wishlistButton.classList.contains('swym-added')
        ? swymcsWishlistFunctions.removeFromWishlist(swat, product)
        : swymcsWishlistFunctions.addToWishlist(swat, product);
    });
  }
}

if (!customElements.get('swymcs-wishlist-button')) customElements.define('swymcs-wishlist-button', SwymWishlistButton);